<template>
<div class="my-5 py-1 text-left">
    <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
        <b-navbar-brand :to="{name:'Home'}" class="Oleo" exact>
            ECER
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto Solway">
                <b-navbar-nav>
                    <b-nav-item :to="{name:'Home'}" exact>({{this.$store.state.clientes.length}}) Clientes</b-nav-item>
                    <!--<b-nav-item :to="{name:'Diagnostico'}">Diagnóstico T</b-nav-item>-->
                    <b-nav-item :to="{name:'Seguimiento'}">Informes</b-nav-item>
                    <!--<b-nav-item :to="{name:'GenerarInforme'}">Informe</b-nav-item>-->

                    <b-nav-item @click="cerrarSesion">Cerrar Sesión</b-nav-item>

                    <!--                    <b-nav-item :to="{name:'guardarvalores'}">guardarvalores</b-nav-item>-->
                </b-navbar-nav>
                <b-nav-form>
                    <b-form-input size="sm" class="mr-sm-2" type="search" placeholder="Buscar" v-model="busqueda"></b-form-input>
                </b-nav-form>

            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</div>
</template>

<script>
import firebase from 'firebase';

export default {
    name: 'BarraNavegacionActivo',
    data() {
        return {
            busqueda: ''
        }
    },
    methods: {
        cerrarSesion() {
            firebase.auth().signOut().then(() => {
                console.log("Cerrar Sesion");
                this.$router.replace('login');
            });
        }
    },
    watch: {
        busqueda() {
            this.$store.state.busqueda = this.busqueda;
        }
    }
}
</script>

<style lang="scss" scoped>
.logo {
    border-radius: 50%;
}
</style>
